export default {
    init() {
        // JavaScript to be fired on the /latest page

        let searchForm = document.querySelector("#post-filter-form");

        let rangePickerArgs = {
            locale: {
                format: 'DD/MM/YYYY',
            },
        }

        /**
         * If date has been set by post lets
         * add the selected date to the new datepicker
         */
        if (searchForm.elements['latest_date_min'].value && searchForm.elements['latest_date_max'].value) {
            let start = new Date(searchForm.elements['latest_date_min'].value * 1000);
            let end = new Date(searchForm.elements['latest_date_max'].value * 1000);

            rangePickerArgs.startDate = ('0' + start.getDate()).slice(-2) + '/' + ('0' + (start.getMonth() + 1)).slice(-2) + '/' + start.getFullYear();
            rangePickerArgs.endDate = ('0' + end.getDate()).slice(-2) + '/' + ('0' + (end.getMonth() + 1)).slice(-2) + '/' + end.getFullYear()
        }

        $("#daterangepicker").daterangepicker(rangePickerArgs, function (start, end) {
            let form = document.getElementById("post-filter-form");

            form.elements['latest_date_min'].value = start.format("X");
            form.elements['latest_date_max'].value = end.format("X")
        });

        $("#daterangepicker").on("apply.daterangepicker", function (){
            document.querySelector("#post-filter-form").submit();
        });
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/latestPosts.js